import { render, staticRenderFns } from "./tempModel.vue?vue&type=template&id=0da20850&lang=pug&"
import script from "./tempModel.vue?vue&type=script&lang=js&"
export * from "./tempModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports